import { QueryClient, defaultShouldDehydrateQuery } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

const STALE_TIME_HOURS = Number(import.meta.env.VITE_SESSION_STALE_TIME_IN_HOURS) || 4;

export const PERSIST_KEY = 'ADMIN_REACT_QUERY_OFFLINE_CACHE';

const PERSIST_BUSTER = 'admin-v1';

// Never persist the session identity: it must be revalidated against the server on every load,
// not restored from localStorage (a stale session could otherwise masquerade as authenticated).
const NON_PERSISTED_QUERY_KEYS = ['auth'];

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_HOURS * 60 * 60 * 1000,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  },
});

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
  key: PERSIST_KEY,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  maxAge: STALE_TIME_HOURS * 60 * 60 * 1000,
  buster: PERSIST_BUSTER,
  dehydrateOptions: {
    shouldDehydrateQuery: (query) =>
      !NON_PERSISTED_QUERY_KEYS.includes(query.queryKey[0] as string) &&
      defaultShouldDehydrateQuery(query),
  },
});

export default queryClient;
